export const cssColors = `
/* Named colors */
  --nude-100: #F9F6F3;
  --nude-200: #F7F2EC;
  --nude-300: #F1E9DF;
  --nude-400: #EDE4D7;
  --nude-500: #EDE0D1;
  --nude-600: #EADFD1;
  --nude-700: #E5D7C7;
  --nude-800: #D8C5AE;
  --nude-900: #CBB396;
  --nude-1000: #C5AB8C;
/* Brand colors */
  --primary-200: #f8e5dc;
  --primary-300: #EDD0C4;
  --primary-400: #E4B9A8;
  --primary-500: #DF9D8D;
  --primary-600: #E18670;
  --primary-800: #944D30;

  --tertiary-100: var(--nude-100);
  --tertiary-200: var(--nude-200);
  --tertiary-300: var(--nude-300);
  --tertiary-400: var(--nude-400);
  --tertiary-500: var(--nude-500);
  --tertiary-600: var(--nude-600);
  --tertiary-800: var(--nude-800);
  --tertiary-900: var(--nude-900);
  --tertiary-1000: var(--nude-1000);
/* Tertiary alpha colors, used to add a darker shade over underlying elements. */
  --tertiary-alpha-10: #C5AB8C1A; // 10%
  --tertiary-alpha-20: #C5AB8C33; // 20%
  --tertiary-alpha-30: #C5AB8C4D; // 30%
  --tertiary-alpha-40: #C5AB8C66; // 40%
  --tertiary-alpha-50: #C5AB8C80; // 50%
  --tertiary-alpha-60: #C5AB8C99; // 60%
  --tertiary-alpha-70: #C5AB8CB3; // 70%
  --tertiary-alpha-80: #C5AB8CCC; // 80%
  --tertiary-alpha-90: #C5AB8CE6; // 90%
/* Semantic colors */
  --header-text-color: #252423;
  --link-text-color: var(--primary-600);
  --body-text-color: #222;
  --tertiary-text-color: #543d26;
  --deemphasized-text-color: #a8a8a8;
  --primary-btn-color: #D57058;
  --primary-btn-hover: var(--primary-800);

  --border-color-medium: #e2e2e2;
  --border-color-light: #e8e8e8;

  --app-cta-btn: var(--primary-600);
  --app-cta-btn-hover: var(--primary-800);

  --app-default-btn-bg: var(--nude-100);
  --app-default-btn-fg: #111;
  --app-default-btn-bg-hover: var(--nude-200);

  --canvas-background: #FCFBF9;
  --surface-background: #fff;
  --content-separator-light: rgba(0,0,0,.065);
  --content-separator-medium: rgba(0,0,0,.15);
  --content-separator-dark: rgba(0,0,0,.25);

  --highlight-background: #fff5c2;

  --danger-main: #E53131;
  --success-light: #a2cec3;
  --success-main: #5F9688;
  --success-dark: #437063;
  --warning-light: #fffac0;
  --warning-main: #edb64f;
  --info-light: #A9C1D2;
  --info-main: #6592b6;

  --email-sent: #e2f1ff;
  --email-opened: #d6f9d7;
  --email-unopened: #fff1e3;
/* Tables */
  --table-header: var(--nude-100);
  --table-row: #fff;
  --table-row-hover: #f9f9f9;
  --table-row-selected: var(--highlight-background);
/* Forms */
  --input-color: #000;
  --input-background: #fff;
  --input-background-hover: #f7f7f7;
  --form-control-active: #ededed;
  --input-border: #dadee2;
  --input-border-hover: #97a1a0;
  --input-border-focus: #97a1a0;
  --input-placeholder: #bdc3c7;
/* Groups */
  --group-color-0: #9a70cd;
  --group-color-1: #bb6755;
  --group-color-2: #7094b3;
  --group-color-3: #cea548;
  --group-color-4: #50b7e0;
  --group-color-5: #3e9c87;
  --group-color-6: #cd709f;
  --group-color-7: #709ecd;
  --group-color-8: #7254e0;
  --group-color-9: #cd7a45;
  --group-color-10: #6cb41f;
  --group-color-11: #6e7276;
  --group-color-12: #3543aa;
  --group-color-13: #9ba87f;
  --group-color-14: #a53cc3;
`;
